import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { parseInvoiceData, Value } from '@/pages/ImportFCL/helpers';

type GetPaymentsInquiryResponse = {
  value: Value | string;
};

type Item = {
  label: string;
  value: number;
  items: Item[];
};

type ResponseType = {
  total: number;
  items: Item[];
  resultado: string;
};

type QueryType = {
  marca: string;
  numero: string;
  fecha: string;
  servicio: string;
  entregaDirecta: boolean;
};

export const getPaymentsInquiry = async (
  query: QueryType
): Promise<ResponseType> => {
  try {
    const res = await apiClient.post<GetPaymentsInquiryResponse>(
      Endpoints.PaymentsInquiry,
      query
    );

    if (typeof res.data === 'string') throw new Error(res.data);

    const { value } = res.data;

    if (typeof value === 'string') throw new Error(value);
    if (value?.error) throw new Error(value?.error);

    const result = parseInvoiceData({ data: value });

    return result as ResponseType;
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      if (error.response.status === 404) {
        throw new Error(error?.response?.data || 'Invalid Data');
      } else {
        throw new Error(error.message);
      }
    } else {
      throw error;
    }
  }
};
